module.exports = __webpack_public_path__ + "static/img/qrcodeImg.1ac0248.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcodeImg.jpg
// module id = YHa0
// module chunks = 21